import { render } from "./Collection.vue?vue&type=template&id=04c57414&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"

import "./Collection.vue?vue&type=style&index=0&id=04c57414&scoped=true&lang=css"

import exportComponent from "/Users/beerebeerey/github-classroom/MUICCS/cs340prj-beersilver/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c57414"]])

export default __exports__